<!-- Loop através das seções do menu -->
@for (section of visibleSections(); track section.id) {
    <!-- Seção com accordion (ex: Minha Área) -->
    @if (section.isAccordion) {
        <li class="accordion menu nav-item">
            <button
                type="button"
                class="nav-link group w-full"
                [ngClass]="{ active: isAccordionActive(section.id) }"
                (click)="toggleAccordion(section.id)"
            >
                <div class="flex items-center">
                    <ng-container
                        [ngTemplateOutlet]="iconTemplate"
                        [ngTemplateOutletContext]="{ icon: section.icon }"
                    ></ng-container>
                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                        {{ section.title | translate }}
                    </span>
                </div>
                <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !isAccordionActive(section.id) }">
                    <icon-caret-down />
                </div>
            </button>
            <div
                [@slideDownUp]="!isAccordionActive(section.id)"
                class="accordion-content"
            >
                <ul class="sub-menu text-gray-500">
                    @for (item of getVisibleItems(section.items); track item.id) {
                        <li>
                            <a
                                [routerLink]="item.route"
                                [queryParams]="item.queryParams"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                            >
                                {{ item.title | translate }}
                            </a>
                        </li>
                    }
                </ul>
            </div>
        </li>
    }

    <!-- Seção com título e itens (ex: Vigilância) -->
    @else {
        <!-- Título da seção -->
        <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
            <icon-minus class="hidden h-5 w-4 flex-none" />
            <span>{{ (section.title | translate) || '&nbsp;' }}</span>
        </h2>

        <!-- Itens da seção -->
        <li class="nav-item">
            <ul>
                @for (item of getVisibleItems(section.items); track item.id) {
                    <!-- Item simples (sem filhos) -->
                    @if (!hasChildren(item)) {
                        <li class="nav-item">
                            <a
                                [routerLink]="item.route"
                                [queryParams]="item.queryParams"
                                class="group"
                                routerLinkActive="active"
                            >
                                <div class="flex items-center">
                                    <ng-container
                                        [ngTemplateOutlet]="iconTemplate"
                                        [ngTemplateOutletContext]="{ icon: item.icon }"
                                    ></ng-container>
                                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                        {{ item.title | translate }}
                                    </span>
                                </div>
                            </a>
                        </li>
                    }

                    <!-- Item com accordion (ex: Relatórios, Checklists) -->
                    @else {
                        <li class="accordion menu nav-item">
                            <button
                                type="button"
                                class="nav-link group w-full"
                                [ngClass]="{ active: isAccordionActive(item.id) }"
                                (click)="toggleAccordion(item.id)"
                            >
                                <div class="flex items-center">
                                    <ng-container
                                        [ngTemplateOutlet]="iconTemplate"
                                        [ngTemplateOutletContext]="{ icon: item.icon }"
                                    ></ng-container>
                                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                        {{ item.title | translate }}
                                    </span>
                                </div>
                                <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !isAccordionActive(item.id) }">
                                    <icon-caret-down />
                                </div>
                            </button>
                            <div
                                [@slideDownUp]="!isAccordionActive(item.id)"
                                class="accordion-content"
                            >
                                <ul class="sub-menu text-gray-500">
                                    @for (child of getVisibleItems(item.children || []); track child.id) {
                                        <li>
                                            <a
                                                [routerLink]="child.route"
                                                [queryParams]="child.queryParams"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{ exact: true }"
                                            >
                                                {{ child.title | translate }}
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </li>
                    }
                }
            </ul>
        </li>
    }
}

<!-- Template reutilizável para ícones -->
<ng-template
    #iconTemplate
    let-icon="icon"
>
    @if (icon) {
        @switch (icon) {
            @case ('menu-dashboard') {
                <icon-menu-dashboard class="shrink-0 group-hover:!text-primary" />
            }
            @case ('briefcase') {
                <icon-briefcase class="shrink-0 group-hover:!text-primary" />
            }
            @case ('report') {
                <icon-report class="shrink-0 group-hover:!text-primary" />
            }
            @case ('security') {
                <icon-security class="shrink-0 group-hover:!text-primary" />
            }
            @case ('patrol') {
                <icon-patrol class="shrink-0 group-hover:!text-primary" />
            }
            @case ('users') {
                <icon-users class="shrink-0 group-hover:!text-primary" />
            }
            @case ('calendar') {
                <icon-calendar class="shrink-0 group-hover:!text-primary" />
            }
            @case ('clock') {
                <icon-clock class="shrink-0 group-hover:!text-primary" />
            }
            @case ('car') {
                <icon-car class="shrink-0 group-hover:!text-primary" />
            }
            @case ('posts') {
                <icon-posts class="shrink-0 group-hover:!text-primary" />
            }
            @case ('alert') {
                <icon-info-triangle class="shrink-0 group-hover:!text-primary" />
            }
            @case ('link') {
                <icon-link class="shrink-0 group-hover:!text-primary" />
            }
            @default {
                <i [class]="'icon-' + icon + ' shrink-0 group-hover:!text-primary'"></i>
            }
        }
    }
</ng-template>
